module.exports = __webpack_public_path__ + "img/dashboard-section-connect.80703876.svg";